import styled, { css } from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

type StyledServiceProvidingLocationCellProps = {
   $important: boolean;
};

export const StyledServiceProvidingLocationCell = styled(StyledFlex)<StyledServiceProvidingLocationCellProps>`
   overflow: hidden;
   height: 100%;
   padding: 11px 8px;
   justify-content: center;

   ${(props) =>
      props.$important &&
      css`
         background-color: ${props.theme.primaryBackground};
      `}

   > * {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
   }
`;
